import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link as RouterLink } from 'react-router';
import { Link } from '@zola/zola-ui';
import { redirectToChart } from '../../../../actions/SeatingChartActions';
import { showModal } from '../../../../actions/ModalActions';
import Tag from '../../common/Tag/Tag';

import TableDecorLink from '../../common/TableDecorLink';
import Dropdown from './Dropdown/Dropdown';

import FeatureFlag from '../../../../util/featureFlags';

import './Header.styles.less';

const Header = ({ seatingChart, events, onChangeSelected, onShowTips, shortenCopy }) => {
  const currentChartSelected = {
    uuid: seatingChart.uuid,
    event: seatingChart.event_id,
    name: seatingChart.name,
  };
  const listingUrl = FeatureFlag.get('seatingChartLanding')
    ? '/wedding/manage/seating'
    : '/wedding/manage/events';

  return (
    <header className="sc__header">
      <div className="sc__contact-us">
        Have Feedback?{' '}
        <Link href="mailto:support@zola.com?subject=Seating Chart Feedback">Reach Out Anytime</Link>
      </div>

      <div className="sc__nav">
        <Tag className="sc__beta tag-primary">Beta</Tag>
        <h1 className="sc__label">Seating Chart:</h1>
        <Dropdown
          list={events}
          selected={currentChartSelected}
          onChangeSelected={onChangeSelected}
        />
      </div>
      <div className="sc__right-group">
        <TableDecorLink className="btn__shop-decor" shortenCopy={shortenCopy} />
        <div className="sc__tips">
          <Link role="button" onClick={onShowTips}>
            <i className="zolaicon zolaicon-tips sc__tips-icon" />
            <span className="sc__tips-label">Tips</span>
          </Link>
        </div>
        <div className="sc__close-button">
          <RouterLink to={listingUrl}>
            <i className="zolaicon zolaicon-close sc__close-icon" />
          </RouterLink>
        </div>
      </div>
    </header>
  );
};

const mapStateToProps = state => ({
  seatingChart: state.seatingChart.seatingChart,
  events: state.seatingChart.events,
});

const mapDispatchToProps = dispatch => ({
  onChangeSelected: chartDetails => dispatch(redirectToChart(chartDetails.uuid)),
  onShowTips: () => dispatch(showModal('SEATING_TIPS_MODAL', {}, { size: 'md' })),
});

Header.propTypes = {
  seatingChart: PropTypes.shape({
    uuid: PropTypes.string,
    event_id: PropTypes.number,
    name: PropTypes.string,
  }),
  events: PropTypes.arrayOf(PropTypes.shape({})),
  onChangeSelected: PropTypes.func,
  onShowTips: PropTypes.func,
  shortenCopy: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/Header/Header.jsx